export class IMonth {
  name: string = ''
  start: string = ''
  end: string = ''
}
